// extracted by mini-css-extract-plugin
export default {"container":"q3D9aind25ITwJU0LK9d","title":"yK0wq4_Nl8qN6VN4u9xG","value":"Ap7jepdSFbDbnXDEhYKU"};